/**
 * Legacy-safe product taxonomy readers (fail-safe missing → empty).
 * Keep in sync with functions/products/productTaxonomyFields.js semantics.
 */

export function readProductTaxonomyFields(product = {}) {
  return {
    catalogTaxonomyAssignmentIds: Array.isArray(product.catalogTaxonomyAssignmentIds)
      ? [...product.catalogTaxonomyAssignmentIds]
      : [],
    catalogTaxonomyMembershipIds: Array.isArray(product.catalogTaxonomyMembershipIds)
      ? [...product.catalogTaxonomyMembershipIds]
      : [],
    canonicalCatalogTaxonomyNodeId:
      typeof product.canonicalCatalogTaxonomyNodeId === 'string'
        ? product.canonicalCatalogTaxonomyNodeId
        : null,
    catalogTaxonomyUpdatedAt: product.catalogTaxonomyUpdatedAt ?? null,
  }
}

export function hasCatalogTaxonomyAssignments(product) {
  return readProductTaxonomyFields(product).catalogTaxonomyAssignmentIds.length > 0
}

export function isProductSchemaV1(product) {
  return Number(product?.schemaVersion) === 1
}
